import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"

// Datetime picker for Super Fan Share publish_at field.
// The picker shows the user's local time; the hidden input stores UTC for the backend.
export default class extends Controller {
  static targets = ["picker", "hidden", "tzLabel", "error", "submit"]

  connect() {
    this.fp = flatpickr(this.pickerTarget, {
      enableTime: true,
      time_24hr: true,
      dateFormat: "Y-m-d H:i",
      allowInput: true,
      disableMobile: true,
      onChange: (_selectedDates, _dateStr, instance) => {
        this.syncFromPicker(instance)
      },
      onClose: (_selectedDates, _dateStr, instance) => {
        this.syncFromPicker(instance)
      }
    })

    const fmt = new Intl.DateTimeFormat("en-US", { timeZoneName: "short" })
    const tzPart = fmt.formatToParts(new Date()).find(p => p.type === "timeZoneName")
    this.tzLabelTarget.textContent = `(${tzPart.value})`

    this.element.addEventListener("submit", (e) => this.handleSubmit(e))
  }

  disconnect() {
    if (this.fp) this.fp.destroy()
  }

  syncFromPicker(instance) {
    const selected = instance.selectedDates[0]
    if (!selected) {
      this.hiddenTarget.value = ""
      this.clearError()
      return
    }
    this.hiddenTarget.value = this.localToUtc(selected)
    this.validate(selected)
  }

  localToUtc(localDate) {
    const y = localDate.getUTCFullYear()
    const m = String(localDate.getUTCMonth() + 1).padStart(2, "0")
    const d = String(localDate.getUTCDate()).padStart(2, "0")
    const h = String(localDate.getUTCHours()).padStart(2, "0")
    const min = String(localDate.getUTCMinutes()).padStart(2, "0")
    return `${y}-${m}-${d} ${h}:${min}`
  }

  validate(localDate) {
    const twoHoursFromNow = new Date(Date.now() + 2 * 60 * 60 * 1000)
    if (localDate.getTime() < twoHoursFromNow.getTime()) {
      this.showError("Must be at least 2 hours in the future")
      return false
    }
    this.clearError()
    return true
  }

  showError(msg) {
    this.errorTarget.textContent = msg
    this.errorTarget.style.display = "block"
    this.submitTarget.disabled = true
  }

  clearError() {
    this.errorTarget.textContent = ""
    this.errorTarget.style.display = "none"
    this.submitTarget.disabled = false
  }

  handleSubmit(e) {
    const selected = this.fp.selectedDates[0]
    if (selected && !this.validate(selected)) {
      e.preventDefault()
    }
    if (this.pickerTarget.value && !selected) {
      const parsed = this.fp.parseDate(this.pickerTarget.value, "Y-m-d H:i")
      if (parsed) {
        this.hiddenTarget.value = this.localToUtc(parsed)
        if (!this.validate(parsed)) e.preventDefault()
      }
    }
  }
}
